import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import IcNaverBlog from "../assets/img/IcNaverBlog.png";
import {
  FooterBorder,
  FooterDesc,
  FooterFirstTitle,
  FooterFirstTitleImgWrapper,
  FooterImg,
  FooterSection,
  FooterWrapper,
  FooterTitle,
  FooterTitleImgWrapper,
  FooterLinksWrapper,
  FooterLink,
} from "./Footer.style";
import { openInNewTab } from "util/Handler";
import { ContentContainer } from "routes/Landing.style";
import { removeBrTag } from "routes/Landing";
import TermsOfServiceModal from "./common/TermsOfServiceModal";


const Footer = () => {
  const history = useHistory();
  const [showTermsModal, setShowTermsModal] = useState(false);
  const isMobile = window.matchMedia("(max-width: 768px)").matches;

  const fooerBlogText = () => {
    const text = isMobile
      ? "더 많은 법률 이야기는\n블로그에서 확인해주세요!"
      : "더 많은 법률 이야기는 블로그에서 확인해주세요!";
    return removeBrTag(text);
  };

  const handleTermsClick = (e) => {
    e.preventDefault();
    if (isMobile) {
      // 모바일: 페이지로 이동
      history.push("/terms-of-service");
    } else {
      // 웹: 모달 표시
      setShowTermsModal(true);
    }
  };

  return (
    <FooterSection>
      <ContentContainer>
        <FooterWrapper>
          <FooterFirstTitleImgWrapper
            onClick={() => {
              openInNewTab("https://blog.naver.com/by-law");
            }}
          >
            <FooterImg src={IcNaverBlog} />
            <FooterFirstTitle>
              {fooerBlogText()}
            </FooterFirstTitle>
            <a href="https://m.blog.naver.com/by-law/223231563121"/>
          </FooterFirstTitleImgWrapper>
          <FooterBorder />
          <FooterLinksWrapper>
            <FooterLink onClick={handleTermsClick}>
              서비스 이용약관
            </FooterLink>
          </FooterLinksWrapper>
          <FooterTitleImgWrapper>
            <FooterTitle>변호사 최윤호 법률사무소</FooterTitle>
          </FooterTitleImgWrapper>
          <FooterDesc>
            대표변호사 : 최윤호 | 광고책임변호사 최윤호
            <br />
            사업자등록번호 : 710-02-03170
            <br />
            서울특별시 종로구 종로3길 38 | 대표 전화 : 010-2864-4488
            <br />
            Copyright © Justitia Co.Ltd. All Rights Reserved
          </FooterDesc>
        </FooterWrapper>
      </ContentContainer>
      <TermsOfServiceModal
        isOpen={showTermsModal}
        onRequestClose={() => setShowTermsModal(false)}
      />
    </FooterSection>
  );
};

export default Footer;
